import { DateTime } from 'luxon'
import { createContext, ReactNode } from 'react'

type DateTimeContextValue = {
  /** 現在の日時（日本時間）を取得する関数 */
  getNowJST: () => DateTime
}

const defaultValue: DateTimeContextValue = {
  getNowJST: () => DateTime.now().setZone('Asia/Tokyo'),
}

export const DateTimeContext = createContext<DateTimeContextValue>(defaultValue)

export const DateTimeProvider = ({ children }: { children: ReactNode }) => {
  const value = {
    getNowJST: () => DateTime.now().setZone('Asia/Tokyo'),
  }

  return <DateTimeContext.Provider value={value}>{children}</DateTimeContext.Provider>
}
